<template>
  <el-dropdown
    :class="classes"
    v-bind="{ ...$attrs }"
    @command="handleItemClick"
    @visible-change="handleVisible"
  >
    <span
      class="el-dropdown-link"
      :class="{ 'has-icon': icon || $scopedSlots['icon'] }"
      :style="[styleObject]"
      :data-item="item.value"
    >
      <em v-if="icon || $scopedSlots['icon']">
        <slot name="icon">
          <font-awesome-icon
            v-if="icon"
            :icon="icon"
            size="1x"
          ></font-awesome-icon>
        </slot>
      </em>
      {{ label }}
      <i class="el-icon-caret-bottom el-icon--right"></i>
    </span>
    <el-dropdown-menu
      ref="dropdown"
      slot="dropdown"
      class="tg-dropdown--menu"
      :class="menuClass"
      :data-key="ekey"
    >
      <template v-for="(item, i) in compiledItems">
        <el-dropdown-item
          :command="item"
          :key="i"
          v-if="item.show != false"
          :disabled="item.disabled == true"
          :data-item="item.value"
          :class="item.class"
          >{{ item.label }}</el-dropdown-item
        >
      </template>
    </el-dropdown-menu>
  </el-dropdown>
</template>

<script>
export default {
  name: "TgDropdown",
  data() {
    return {
      compiledItems: [],
      item: null,
      defLabel: "請選擇",
      visible: false,
    };
  },
  props: {
    menuClass: [Object, String, Array],
    items: Array,
    icon: [String, Array],
    value: {
      type: [Object, String, Number],
      default: () => ({}),
    },
    select: [Object, String, Number],
    autoWidth: {
      type: Boolean,
      default() {
        return true;
      },
    },
    styleObject: [Object],
    width: [Number, String],
    ekey: String,
  },
  computed: {
    classes() {
      return ["tg-dropdown", { visible: this.visible }];
    },
    label() {
      // 優先使用 item.label
      if (this.item && this.item.label) {
        return this.item.label;
      }

      // 如果沒有 item，嘗試使用第一個項目
      if (!this.initialized && this.compiledItems.length > 0) {
        return this.compiledItems[0].label;
      }

      // 使用 placeholder 或國際化
      return this.placeholder || this.$t("component.dropdown.default");
    },
  },
  created() {
    this.initializeComponent();
  },
  mounted() {
    this.$nextTick(() => {
      if (!this.initialized) {
        this.initializeComponent();
      }
    });
    // this.resizeWidth();
  },
  methods: {
    initializeComponent() {
      // 檢查 items 是否有效
      if (!this.items || this.items.length === 0) {
        return;
      }

      // 解析 items
      this.compiledItems = this.parseItems(this.items);

      console.log("this.value", this.value);
      console.log("this.item", this.item);

      // 設置初始值
      if (this.value) {
        this.value2Item(this.item);
      } else if (this.select) {
        this.selectItem(this.select);
      } else if (!this.item && this.compiledItems.length > 0) {
        // 如果沒有指定值，使用第一個項目
        this.item = this.compiledItems[0];
      }

      this.initialized = true;
    },
    resizeWidth() {
      if (this.autoWidth && this.$el.clientWidth) {
        this.$refs.dropdown.$el.style.width = this.$el.clientWidth + "px";
      } else if (this.width) {
        this.$refs.dropdown.$el.style.width = parseInt(this.width) + "px";
      }
    },
    parseItems(items) {
      let tmp = JSON.parse(JSON.stringify(items));

      tmp = tmp.map((x) => {
        let isObj = typeof x === "object";

        x = isObj
          ? x
          : {
              label: x,
              value: x,
            };

        if (x.active) {
          this.item = x;
        }
        return x;
      });

      let active = tmp.find((x) => !!x.active);
      this.item = active ? active : tmp[0];

      return tmp;
    },
    parseIcon(item) {
      let icon = "tg-icon-radio";

      if (this.item.value === item.value) {
        icon += " active";
      }
      return icon;
    },
    handleItemClick(item) {
      this.item = item;
      this.$emit("on-change", item);
    },
    handleVisible(visible) {
      this.visible = visible;
    },
    value2Item(val) {
      if (typeof val !== "object") {
        val = {
          value: val,
          label: val,
        };
      }
      this.item = val;
    },
    selectItem(val) {
      let item = this.compiledItems.find((x) => x.value == val);
      this.item = item;
      this.$emit("on-change", item);
    },
  },
  watch: {
    items: {
      handler(val) {
        if (val && val.length > 0) {
          this.compiledItems = this.parseItems(val);

          // 如果還沒有選中項目，使用第一個
          if (!this.item) {
            this.item = this.compiledItems[0];
          }
        }
      },
      immediate: true, // ← 重要
      deep: true,
    },

    value: {
      handler(val) {
        if (val) {
          this.value2Item(val);
        }
      },
      immediate: true, // ← 重要
    },
  },
};
</script>
